import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import StyledPulse from './styles';
const Pulse = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    return React.createElement(StyledPulse, { className: className, size: size, color: color });
};
export default Pulse;
//# sourceMappingURL=index.js.map